// extracted by mini-css-extract-plugin
export default {"container":"Introductory_container__bURE+","page":"Introductory_page__HcMxj","section":"Introductory_section__ZCfK6"};